import styled from "@emotion/styled";

export const Note = styled.div`
    color: #5F5F5F;
    font-size: 14px;
    font-weight: 300;
    margin-left: 16px;

`;


export const SubRowGroup = styled.div`
    display: grid;
    row-gap: 16px;
    width: 100%;
`;